document.addEventListener('DOMContentLoaded', initBentoAnimations)
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('.bento-gallery-grid')) {
    initBentoAnimations()
  }
})

function initBentoAnimations() {
  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)',
  ).matches
  if (prefersReducedMotion) return

  if (window.bentoGalleryCtx) {
    window.bentoGalleryCtx.revert()
  }

  window.bentoGalleryCtx = gsap.context(() => {
    // Select all the elements we mapped in the Liquid file
    const revealElements = document.querySelectorAll('[data-gsap="bento-reveal"]')
    const gradients = document.querySelectorAll('[data-gsap="bento-gradient"]')
    const content = document.querySelectorAll('[data-gsap="bento-content"]')

    if (revealElements.length === 0) return

    const cards = gsap.utils.toArray('.bento-item')
    const images = gsap.utils.toArray('.bento-image')

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '.bento-gallery-grid',
        start: 'top 80%',
        once: true,
      }
    })

    tl.from(cards, {
      opacity: 0,
      y: 80,
      scale: 0.96,
      duration: 1.2,
      stagger: {
        each: 0.12,
        from: "start"
      },
      ease: "power4.out"
    })
    .from(
      ".bento-card-content",
      {
        opacity: 0,
        y: 20,
        duration: .8,
        stagger: .08,
        ease: "power3.out"
      },
      "-=.8"
    )

    //-------------------------------------
    // Ambient Floating Motion
    //-------------------------------------
    // Float the images using yPercent to avoid conflicts with mousemove (which uses y in pixels)
    images.forEach((img, index) => {
      gsap.to(img, {
        yPercent: index % 2 === 0 ? -3 : 3,
        duration: 8 + index,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut"
      })
    })

    // Ambient slow scaling for background images
    images.forEach((img, index) => {
      gsap.to(img, {
        scale: 1.06,
        duration: 20 + index * 2,
        repeat: -1,
        yoyo: true,
        ease: "none"
      })
    })

    // Ambient opacity shift for gradient overlays
    gradients.forEach((overlay, index) => {
      gsap.to(overlay, {
        opacity: .82,
        duration: 6 + index,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut"
      })
    })

    // Mouse interactive parallax effects
    document.querySelectorAll(".bento-inner").forEach(card => {
      const imageElement = card.querySelector(".bento-image")
      const content = card.querySelector(".bento-card-content")
      const gradient = card.querySelector(".bento-gradient-overlay")

      card.addEventListener("mousemove", (e) => {
        const rect = card.getBoundingClientRect()
        const x = (e.clientX - rect.left) / rect.width - .5
        const y = (e.clientY - rect.top) / rect.height - .5

        if (imageElement) {
          gsap.to(imageElement, {
            x: x * 18,
            y: y * 18,
            duration: 1.2,
            ease: "power3.out"
          })
        }

        if (gradient) {
          gsap.to(gradient, {
            x: x * 8,
            y: y * 8,
            duration: 1.2
          })
        }

        if (content) {
          gsap.to(content, {
            x: x * 5,
            y: y * 5,
            duration: 1
          })
        }
      })

      card.addEventListener("mouseleave", () => {
        const targets = []
        if (imageElement) targets.push(imageElement)
        if (gradient) targets.push(gradient)
        if (content) targets.push(content)

        if (targets.length > 0) {
          gsap.to(targets, {
            x: 0,
            y: 0,
            duration: 1.5,
            ease: "power3.out"
          })
        }
      })
    })

    // Mobile specific adjustments
    if (window.innerWidth < 990) {
      images.forEach((img, index) => {
        gsap.to(img, {
          scale: 1.08,
          duration: 24 + index,
          repeat: -1,
          yoyo: true,
          ease: "none"
        })
      })
    }

    // Scroll parallax on images
    images.forEach(img => {
      gsap.to(img, {
        yPercent: -10,
        ease: "none",
        scrollTrigger: {
          trigger: img,
          scrub: 1
        }
      })
    })
  })

  if (typeof ScrollTrigger !== 'undefined') {
    ScrollTrigger.refresh()
  }
}
